import { DeepPartial } from '@noths/polaris-dev-ts-recipes';
import { mergeDeepRight } from 'ramda';

import { DeliveryOption } from 'src/types';
import { priceBuilder } from './price';

const defaults: Readonly<DeliveryOption> = {
  zone: { id: 1, name: '', shortName: '', international: false },
  service: { name: '', code: 'FREE', express: false },
  prices: [priceBuilder()],
};

export const deliveryOptionBuilder = (
  overrides: DeepPartial<DeliveryOption> = {},
): Readonly<DeliveryOption> => mergeDeepRight(defaults, overrides) as Readonly<DeliveryOption>;
